<app-module-menu-wrapper
  [title]="title"
  [menuItems]="menuItems"
  style="height: 100%;"
></app-module-menu-wrapper>
